import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'expiryDate'
})
export class ExpiryDatePipe implements PipeTransform {
    private months = {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec'
    };

    transform(expiryDate: string): string {
        let result = '';
        const splittedDate = expiryDate.split('/');

        if (!isNaN(+expiryDate[0]) && !isNaN(+expiryDate[1])) {
            const month = this.months[splittedDate[0]];
            const year = '20' + splittedDate[1];
            result = month + ', ' + year;
        }

        return result;
    }

}
